import React from 'react'

const PackageSlip = () => {
    return (
        <div>PackageSlip</div>
    )
}

export default PackageSlip